/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {SDK} from '@phenixrts/sdk';
export class ChunkedStreaming {
  constructor() {
    throw new Error('ChunkedStreaming is a static class and may not be instantiated');
  }

  static initializePhenixSDKForChunkedStreaming({useShaka, canPlayHls}) {
    const phenixSDKInitObject = {};

    if (useShaka) {
      phenixSDKInitObject.shakaPlayerLoader = (callback) => {
        import(/* webpackChunkName: "shaka-player" */ 'shaka-player').then(module => {
          const shaka = module.default;

          if (!canPlayHls && !shaka.Player.isBrowserSupported()) {
            shaka.polyfill.installAll();
          }

          callback(shaka);
        }).catch(e => {
          console.error('Failed to load shaka', e);

          callback(null);
        });
      };
    } else {
      phenixSDKInitObject.webPlayerLoader = (callback) => import(/* webpackChunkName: "phenix-web-player" */ 'phenix-web-player').then(module => {
        const webPlayer = module.default;

        callback(webPlayer);
      }).catch(e => {
        console.error('Failed to load phenix web player', e);

        callback(null);
      });
    }

    SDK.init(phenixSDKInitObject);
  }
}